import { Component, MouseEvent, ReactNode } from 'react';
import Button, { ButtonProps } from './react-ui-button';

interface Props extends ButtonProps {
  pendingContent?: ReactNode;
  onClick: (mouseEvent: MouseEvent) => Promise<any>;
}

interface State {
  loading: boolean;
}

export default class AsyncButton extends Component<Props, State> {
  public state = { loading: false };

  public _isMounted = false;

  public componentDidMount() {
    this._isMounted = true;
  }

  public componentWillUnmount() {
    this._isMounted = false;
  }

  private getContent() {
    const { content, pendingContent } = this.props;
    return pendingContent && this.state.loading ? pendingContent : content;
  }

  private asyncOnClick = async (event: MouseEvent) => {
    this.setState({ loading: true });
    try {
      await this.props.onClick(event);
    } finally {
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    }
  };

  private isDisabled() {
    return this.state.loading || this.props.disabled;
  }

  public render() {
    return (
      <Button
        {...this.props}
        onClick={this.asyncOnClick}
        displaySpinner={this.state.loading}
        disabled={this.isDisabled()}
      >
        {' '}
        {this.getContent()}{' '}
      </Button>
    );
  }
}
